import { widgetDefaultsFromFields } from "../widgetDefaultsFromFields";

export const POPULAR_BLOGS_1_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Popular blog posts",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_cover_image: "",
    meta_cover_alt: "",
    meta_date_display: "",
    meta_title: "",
    meta_url: "",
    meta_priority: 1,
    meta_status: true,
  },

  POPULAR_BLOGS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Section title",
      value: "Popular Blogs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Section heading",
      required: false,
      defaultValue: "Popular Blogs",
    },
    {
      fieldName: "title_text_color",
      label: "Title color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "accent_color",
      label: "Accent (chevron / read more)",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#BE2330",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "item_divider_color",
      label: "Card border & row dividers",
      value: "#E5E7EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E5E7EB",
      required: false,
      defaultValue: "#E5E7EB",
    },
    {
      fieldName: "read_more_label",
      label: "Featured card — read more label",
      value: "Read More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Read More",
      required: false,
      defaultValue: "Read More",
    },
    {
      fieldName: "fetch_popular_blogs",
      label: "Auto-fill from blog pages",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On: load up to 15 published posts (by last updated). Off: use only the posts you add in the table below.",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Cover image",
      fieldName: "meta_cover_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload cover image",
    },
    {
      header: "Cover alt text",
      fieldName: "meta_cover_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Image description",
    },
    {
      header: "Date (display)",
      fieldName: "meta_date_display",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: 'e.g. Sep 12th, 2024',
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Blog title",
    },
    {
      header: "URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Path or URL (/blog/my-post)",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Order (1 = featured on the left)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Visible",
      defaultValue: true,
    },
  ],
};

export const POPULAR_BLOGS_1_WIDGET_DEFAULTS = {
  ...widgetDefaultsFromFields(
    POPULAR_BLOGS_1_CONSTANTS.POPULAR_BLOGS_FIELDS_CONFIG,
  ),
  metadata: [],
};
